import React, { Component } from 'react';
import './App.css';
import './theme/auth.css';
import { Route, Switch } from "react-router-dom";
import LoginForm from "./LoginForm"
import Register from "./Register"
import RegisterComplete from "./RegisterComplete"
import ResetPassword from "./ResetPassword"

class Landing extends Component {
	constructor(props) {
		super(props)
		this.state ={
		}
	}

	render() {
		return (
            <div className="auth-page">
                <div className="auth-card">
					{/* claude: LoginForm is the CATCH-ALL (last, no path) rather than
					    exact "/". When a protected route 401s mid-session (e.g. an
					    expired token while playing /bookshelf/:titleId), the global
					    interceptor clears the session and the app drops here — but the
					    URL is still /bookshelf/story1, which an `exact path="/"` login
					    route would NOT match, leaving an empty auth card. As the Switch
					    fallthrough, LoginForm renders for ANY logged-out path (register
					    /reset still match first), so the "Session expired" alert lands
					    on an actual login form. */}
					<Switch>
						<Route exact path="/register" component={Register}/>
						<Route exact path="/registerComplete" component={RegisterComplete}/>
						<Route exact path="/requestPasswordReset" component={ResetPassword}/>
						<Route component={LoginForm}/>
					</Switch>
                </div>
            </div>
        );
	}
}

export default Landing;
